module.exports = __webpack_public_path__ + "img/icon_logout.ddef4200.svg";